import { render, staticRenderFns } from "./posLogin.vue?vue&type=template&id=0bf714d4&"
import script from "./posLogin.vue?vue&type=script&lang=js&"
export * from "./posLogin.vue?vue&type=script&lang=js&"
import style0 from "./posLogin.vue?vue&type=style&index=0&scope=true&lang=css&"
import style1 from "./posLogin.vue?vue&type=style&index=1&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports